<template>
  <div style="align-content:center;">
    <div @click="show1 = !show1" class="dt" style="margin-top: 40px"><a class="t"><span>Q1</span> Get an overview of RNAPhaSep from the <b>Home</b> page</a></div>
    <el-collapse-transition>
      <div  class="dn" v-show="show1">
        <h1 class="bt">The homepage is displayed in the following Fig 1-1.</h1>
        <p>1. Main functions of the database are provided in menu bar form (boxed in red).</p>
        <p>2. Other databases contributed by our group.</p>
        <p>3. Cite information.</p>
        <img src="../../assets/img/help1.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 1-1 Home page</p>

      </div>
    </el-collapse-transition>

    <div @click="show2 = !show2" class="dt"><a class="t"><span>Q2</span> How to implement query in <b>Search/Blast</b> page?</a></div>
    <el-collapse-transition>
      <div  class="dn" v-show="show2">
        <h1 class="bt">The Search module is displayed in Fig 2-1:</h1>
        <p>1. Carefully select: Four choices are provided.</p>
        <p>2. Enter a keyword corresponding to selected dataset.</p>
        <p>3. Four categories provided to filter results: Vivo/Vitro, Component type (only apply to vitro), RNA species and RNA type.</p>
        <p>4. Three examples provided.</p>
        <img src="../../assets/img/help2.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 2-1 Search module</p>

        <h1 class="bt">The Blast module is displayed in Fig 2-2:</h1>
        <p>1. Input RNA sequence.</p>
        <img src="../../assets/img/help3.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 2-1 Blast module</p>


      </div>
    </el-collapse-transition>

    <div @click="show3 = !show3" class="dt"><a class="t"><span>Q3</span> How to read <b>search results</b>?</a></div>
    <el-collapse-transition>
      <div  class="dn" v-show="show3">
        <h1 class="bt">To reduce data redundancy, we consolidated the data with RNA-related information, protein name and Vivo/Vitro, and assigned records unique RNAPSID. On this page we mainly present "Table of RNAPSID records", including some summary information that distinguishes the different records including "RNAPSID", "RNA", "RNA length", "RNA type", "RNA species", "Protein name", "Component type" and "Vivo/Vitro".</h1>
        <h1 class="bt">Fig 3-1:</h1>
        <p>1. Total sum of results.</p>
        <p>2. Click to turn the page.</p>
<!--        <p>3. Click to order entries.</p>-->
        <p>3. Click to link to detail page.</p>
        <img src="../../assets/img/help4.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 3-1 results module</p>
      </div>
    </el-collapse-transition>

    <div @click="show4 = !show4" class="dt"><a class="t"><span>Q4</span> How to read <b>Detail</b> page?</a></div>
    <el-collapse-transition>
      <div  class="dn" v-show="show4">
        <h1 class="bt">Detail page consists of three sections, including "RNA(s) information", "Protein(s) information", and "PS experiment and description", of which "Protein information" is not included in all records because some phase separation events only have RNA.</h1>
        <h1 class="bt">Fig 4-1</h1>
        <p>RNA information in phase separation events</p>
        <p>1. Click to link extension page for rna basic information.</p>
        <p>2. Click to see its basic description in NCBI Gene/miRBase/RNAcentral/circBase database.</p>
        <p>3. Hover to see its sequence.</p>
        <p>4. Click to see its structure.</p>
        <img src="../../assets/img/help5.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 4-1 Detail page of RNA(s) Information</p>

        <h1 class="bt">Fig 4-2</h1>
        <p>Protein information in phase separation events</p>
        <p>1. Click "State" to switch between different protein states and corresponding experimental conditions.</p>
        <p>2. Click to see its basic description in Uniprot.</p>
        <p>3. Click to see its information in other protein LLPS databases.</p>
        <p>4. Hover to see its sequence.</p>
        <img src="../../assets/img/help6.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 4-2 Detail page of Protein(s) Information</p>


        <h1 class="bt">Fig 4-3</h1>
        <p>Experimental element information for phase separation events</p>
        <p>1. Click to see phase diagram table.</p>
        <p>2. Hover to see description in the article.</p>
        <p>3. Click to link the article.</p>
        <img src="../../assets/img/help7.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 4-3 Detail page of PS experiment and description</p>
      </div>
    </el-collapse-transition>

    <div @click="show5 = !show5" class="dt"><a class="t"><span>Q5</span> How to read <b>Annotation</b> page?</a></div>
    <el-collapse-transition>
      <div  class="dn" v-show="show5">
        <h1 class="bt">Annotation page consists of two sections, including "RNA basic information" and "The phase separation entry containing this RNA"</h1>
        <h1 class="bt">Fig 5-1</h1>
        <p>1. RNA basic information.</p>
        <p>2. Hover to see the interaction score.</p>
        <p>3. The phase separation records containing this RNA.</p>
        <img src="../../assets/img/help8.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 5-1 Annotation page</p>

      </div>
    </el-collapse-transition>

    <div @click="show6 = !show6" class="dt"><a class="t"><span>Q6</span> How to use <b>Browse</b> by <b>Datasets</b>?</a></div>
    <el-collapse-transition>
      <div  class="dn" v-show="show6">
        <h1 class="bt">Here we provide two classifications based on: In vivo/vitro and RNA type</h1>
        <h1 class="bt">Fig 6-1</h1>
        <p>1. Datasets classified by In vivo/vitro.</p>
        <p>2. Datasets classified by RNA type.</p>

        <p>3. Table of records.</p>

        <img src="../../assets/img/help9.png" width="90%" style="margin-left: 5%;border: 2px solid #13305D" />
        <p style="text-align: center">Fig 6-1 Browse page</p>

      </div>
    </el-collapse-transition>

    <div @click="show7 = !show7" class="dt"><a class="t"><span>Q7</span> <b>Interpretation</b> and <b>naming conventions</b> of fields</a></div>
    <el-collapse-transition>
      <div  class="dn" v-show="show7">
        <h1 class="bt">In "PS experiment and description", if one field are all "-", the field will be hidden.</h1>
        <h1 class="bt">(Note: Symbol "-" means none).</h1>
        <el-divider></el-divider>
        <h1 class="bt">1. RNA related fields:</h1>
        <p class="ip"><a class="it">RNA(s):</a> Specific Gene symbol. <br>For some unusual RNAs: <br>"polyU(10)" represents 10 repeat of URACIL. <br>"Polyriboadenylic (poly(rA))" strands of sufficient length form parallel double helices in acidic and/or ammonium-containing conditions. <br>Poly(rA) duplexes in acidic conditions are held together by A⁺–A⁺ base-pairing also involving base interactions with the phosphate backbone. <br>"(UCAAG)5" represents 5 repeat of "UCAAG" fragment, "(GA-rich U5)30" represents 30 "GA-rich, but single U at position 5". <br>For some irregularity and indescribable RNA, we used the name of the RNA in the article (author's last name, year of the article), like rIGS16RNA-Low complexity (Wang, 2018).<br>
          "_scr" represents scramble, "_ml" represents melt, "_sm" represents structure mutant. "_mut" represents mutant.</p>
        <p class="ip"><a class="it">RNAID:</a> ID form NCBI Gene or RNAcentral.</p>
        <p class="ip"><a class="it">Length:</a> The length of the RNA sequence. "nt" represents number of nucleotides in RNA, "kDa" represents mass of the RNA. </p>
        <p class="ip"><a class="it">Type:</a> We divide RNAs into natural and designed. Natural RNAs include "mRNA", "lncRNA", "miRNA", "rRNA", "siRNA", "snRNA", "total RNA(total RNA in the cell)", "virus RNA". Designed RNAs include "poly RNA", "fragment repeat RNA", "irregular RNA", "nucleotide rich RNA".</p>
        <p class="ip"><a class="it">Species:</a> On detail page, the species of RNA is subdivided as much as possible.</p>
        <p class="ip"><a class="it">Sequence:</a> RNA sequence(s) is/are displayed in FASTA format by "Show" button (Note that post-translational modifications are not manifested in sequence).</p>
        <p class="ip"><a class="it">Structure:</a> Generate minimum free energy (MFE) structure from an RNA sequence. The MFE structure of an RNA sequence is the secondary structure that contributes a minimum of free energy. This structure is predicted using a loop-based energy model and the dynamic programming algorithm. Structure were generated by RNAfold WebServer (Ivo L. Hofacker et al., 2003). In the MFE secondary structure picture, different colours represent the base pair probabilities between 0 and 1.</p>
        <p class="ip"><a class="it">Description:</a> Some other RNA-related information.</p>
        <p class="ip"><a class="it">Molecular function:</a> Molecular functional involved in RNA in the GO database.</p>
        <p class="ip"><a class="it">Subcellular location:</a> The localization of RNA in cells.Subcellular location information were collected from RNALocate database (Zhang T et al., 2017).</p>
        <p class="ip"><a class="it">MIM Number:</a> Gene's MIM Number form OMIM database.</p>
        <p class="ip"><a class="it">Disease:</a> Genes related top5 diseases form DisGeNET database.</p>
        <p class="ip"><a class="it">Interaction neighbours:</a> The algorithm provided by RNAInter database (Lin Y et al., 2020) was used to predict RNA's neighbours and interactions score. TOP100 interaction neighbours shown.</p>
        <el-divider></el-divider>
        <h1 class="bt">2. Protein related fields:</h1>
        <p class="ip"><a class="it">State:</a> As mentioned earlier, "To reduce data redundancy, we consolidated the data with RNA-related information, protein name and Vivo/Vitro, and assigned records unique RNAPSID", so proteins in a entry may have different "Modification", "Length" and "Sequence", and you can click different "State" to switch between different protein states and corresponding experimental conditions.</p>
        <p class="ip"><a class="it">Protein(s):</a> Specific protein name. "-" representative A fusion construction.</p>
        <p class="ip"><a class="it">Length:</a> The length and residue region of the protein sequence. If the sequence region of the protein is known, it is recorded within "()” in a form of "n1-n2” in which "n1” means the initial and "n2” means the ending residue number. <br>For fusion proteins, the region or length of each fused part (if it is known) is separated by ";” within "()”, while the linker part is not noted.</p>
        <p class="ip"><a class="it">IDR:</a> IDR(Internal disordered region) was predicted or proved by "MobiDB" database (Piovesan et al., 2018) with "pondr".</p>
        <p class="ip"><a class="it">LCD:</a> LCD(Low complexity domain) was predicted or proved by "MobiDB" database (Piovesan et al., 2018) with "pondr".</p>
        <p class="ip"><a class="it">Mutations and modification:</a> Modification includes phosphorylation and methylation.<br>
          For example, "protein_mutation:D169G" represents the amino acid at 169 of the protein changes from D to G.</p>
        <p class="ip"><a class="it">Sequence:</a> Protein sequence(s) is/are displayed in FASTA format by "Show" button on this page.</p>
        <el-divider></el-divider>
        <h1 class="bt">3. Experiment and description related fields:</h1>
        <p class="ip"><a class="it">Solute concentration:</a> RNA(s) (and Protein(s)) concentration.</p>
        <p class="ip"><a class="it">Salt concentration:</a> Salt concentration.</p>
        <p class="ip"><a class="it">Buffer:</a> Buffer solution concentration and pH it maintains.</p>
        <p class="ip"><a class="it">Temperature:</a> Experimental temperature ("RT" means room temperature).</p>
        <p class="ip"><a class="it">Incubation time:</a> Experimental incubation time.</p>

        <p class="ip" style="margin-bottom: 0px"><a class="it">Detection method:</a> The experiment technique used to detect phase separation and characterize the phase morphology. General dynamic liquid droplet indications (flow, fuse, reversible) are noted within "()" following the detection method.</p>


        <p class="ip"><a class="it">Phase diagram:</a> Undergoing PS or not. Those noted with "Phase diagram" can be linked to a phase diagram in image.</p>
        <p class="ip"><a class="it">Other requirement:</a> Other requirement include <br>"Crowding agent"(Type and concentration of macromolecular crowding agent used to mimic highly crowded cytoplasm environment), <br>"Other molecular"(Other specific materials), <br>"Drug"(The drug added in the experiment), <br>"Pressure"(Experimental pressure.), <br>"Cell"(cell localization of in vivo experiments), <br>"Organelles"(organelles localization of in vivo experiments).</p>
        <p class="ip"><a class="it">Morphology:</a> A brief annotation of phase morphology. Most are identified as "liquid droplets" or "droplets", while some gel, fiber or aggregate ripen from liquid droplet are also recorded here with "droplet to gel" or "droplet to fiber" term respectively.</p>
        <p class="ip"><a class="it">In vivo/vitro:</a> Whether there is related in vivo/vitro data in the literature.</p>
        <p class="ip"><a class="it">Description:</a> Description of phase separation tendency extracted from literature.</p>
        <p class="ip"><a class="it">PMID:</a> PubMed ID of literature.</p>
        <el-divider></el-divider>
        <h1 class="bt">References:</h1>
        <p class="ip">Hofacker IL. Vienna RNA secondary structure server. Nucleic Acids Res. 2003;31(13):3429-3431.</p>
        <p class="ip">Zhang T, Tan P, Wang L, et al. RNALocate: a resource for RNA subcellular localizations. Nucleic Acids Res. 2017;45(D1):D135-D138.</p>
        <p class="ip">Lin Y, Liu T, Cui T, et al. RNAInter in 2020: RNA interactome repository with increased coverage and annotation. Nucleic Acids Res. 2020;48(D1):D189-D197.</p>
        <p class="ip">Piovesan D, Tabaro F, Paladin L, et al. MobiDB 3.0: more annotations for intrinsic disorder, conformational diversity and interactions in proteins. Nucleic Acids Res. 2018;46(D1):D471-D476. </p>
        <p></p>
      </div>
    </el-collapse-transition>
    <div style="margin-bottom: 40px"></div>

<!--    <div @click="show8 = !show8" class="dt"><a class="t"><span>Q8</span> 8</a></div>-->
<!--    <el-collapse-transition>-->
<!--      <div  class="dn" v-show="show8">-->
<!--        s-->
<!--      </div>-->
<!--    </el-collapse-transition>-->

<!--    <div @click="show9 = !show9" class="dt" style="margin-bottom: 40px"><a class="t"><span>Q9</span> 9</a></div>-->
<!--    <el-collapse-transition>-->
<!--      <div  class="dn" v-show="show9">-->
<!--        s-->
<!--      </div>-->
<!--    </el-collapse-transition>-->




  </div>
</template>

<script>



export default {
  name: "Help",
  data() {
    return {
      show1:false,
      show2:false,
      show3:false,
      show4:false,
      show5:false,
      show6:false,
      show7:false,
      show8:false,
      show9:false,
    }
  },
}
</script>

<style scoped>
.title{
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 5px;
  margin-top: 50px;
}
.t{
  font-size: 1.3rem;
  padding: 10px 20px 10px 20px;
  margin-left: 0px;
}
.dt{
  border: #13305D 2px solid;
  display:flex;
  color: #13305D;
  margin-top:20px;
  cursor: pointer;
  align-items:center;
  border-radius: 10px;
  width: 70%;
  margin-left: 15%;
}
span{
  font-weight: bold;
  color: #13305D;
  padding-right: 20px;
}

.dt:hover{
  color: #409EFF;
}

.dn{
  border: #606266 2px solid;
  justify-content:center;
  align-items:center;
  border-radius: 10px;
  width: 70%;
  margin-left: 15%;
}
.bt{
  font-size: 1.2rem;
  padding-left: 30px;

}
a{
  font-size: 1.1rem;
  margin-left: 30px;
}
p{
  font-size: 1.1rem;
  padding: 0px 30px;
  margin: 15px 0px;
}
.it{
  margin-left: 0px;
  color: black;
  font-weight: bold;
}
.ip{
  color: rgb(96, 98, 102);
}

</style>